import React, { useEffect, useState } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { useAuth } from './contexts/AuthContext'
import { performHardReset } from './utils/updateUtils'
import { RotateCw, X, Sparkles } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import UpdateSuccessModal from './components/UpdateSuccessModal'

function ReloadPrompt() {
    const { user } = useAuth()
    const { t } = useTranslation()
    const [showSuccess, setShowSuccess] = useState(false)

    const {
        offlineReady: [offlineReady, setOfflineReady],
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegistered(r) {
            console.log('SW Registered: ' + r)
        },
        onRegisterError(error) {
            console.log('SW registration error', error)
        },
    })

    const close = () => {
        setOfflineReady(false)
        setNeedRefresh(false)
    }

    useEffect(() => {
        if (needRefresh) {
            console.log('[SW] New version detected, auto-updating...');
            handleConfirmUpdate();
        }
    }, [needRefresh]);

    const handleUpdate = () => {
        setShowSuccess(true)
    }

    const handleConfirmUpdate = async () => {
        // Clear caches and reload
        await performHardReset()
        // Wait a bit then update SW
        if (updateServiceWorker) {
            await updateServiceWorker(true)
        }
    }

    // Only show after login
    if (!user) return null;

    if (!offlineReady && !needRefresh) return null;

    return null;
}

export default ReloadPrompt
